import React from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import {
  Container,
  BgImage,
  IntroHeader,
  IntroText,
  IntroBtn
} from './IntroElements'

function Intro(props) {

  const {intro} = props

  return(
    <Container
    container
    justify="center"
    alignItems="center"
    direction="column"
    style={{scrollBehavior: "smooth"}}
    >
      <BgImage intro={intro[2].value}>
        {/* <img src={intro[2].value}></img> */}
      </BgImage>
      <Grid
         container
         justify="center"
         alignItems="center"
         direction="column"
         textAlign="center"
      
         
         style={{
            lineHeight: "5",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            textAlign:"center",
            fontFamily:"Raleway",
            fontStyle:"bold"
            

         }}
        >
        <Grid item xs={12} md={6} lg={6}>  
          <Typography  variant="h2">
            {intro[0].value}
           
          </Typography>
        </Grid>
        <Grid item xs={12} md={5}  lg={6}>
          <Typography  variant="h4">
          {intro[1].value}
          </Typography>
        </Grid>
        
        
        <IntroBtn to="prijavise"
        smooth={true} duration={500} spy={true} exact='true' offset={-80}>
          <Typography variant="h4">
            Prijavi se
          </Typography>
        </IntroBtn>
        
        
        </Grid>
    </Container>
  )
} 

export default Intro;
